import { render, staticRenderFns } from "./publicityList.vue?vue&type=template&id=d01d2710"
import script from "./publicityList.vue?vue&type=script&lang=js"
export * from "./publicityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports